import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueRouter from 'vue-router';
import vuetify from './plugins/vuetify';
import store from '@/store/index';
import axios from 'axios'; 
import '@/plugins/apexcharts';

Vue.prototype.$store = store;
Vue.config.productionTip = false;

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      alert('Su sesión ha expirado');
      store.commit('RESET_ALL');
      router.push('/');
    }
    return Promise.reject(error);
  }
);

const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      return err;
    }
    return Promise.reject(err);
  });
};

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');
